import { IconsListNew } from 'src/partials/IconsListNew.tsx';
import * as React from 'react';
export default {
  IconsListNew,
  React
};